
import { EntityConfig } from '@/types/research-attachments';

/**
 * Builds the select query string for research attachments
 */
export const buildSelectQuery = (config: EntityConfig): string => {
  const baseFields = `
    id,
    ${config.entityIdColumn},
    research_id,
    research_summary,
    created_at,
    user_id,
    ${config.entityType === 'page' ? 'attachment_order,' : ''}
    research_library (
      id,
      title,
      content,
      research_type,
      created_at
    )
  `;
  
  return baseFields.trim();
};

/**
 * Builds insert data object for new attachments
 */
export const buildInsertData = (
  config: EntityConfig,
  entityId: string,
  researchId: string,
  userId: string,
  attachmentOrder?: number
): Record<string, any> => {
  const insertData: Record<string, any> = {
    [config.entityIdColumn]: entityId,
    research_id: researchId,
    user_id: userId,
  };

  if (config.entityType === 'page' && attachmentOrder !== undefined) {
    insertData.attachment_order = attachmentOrder;
  }

  return insertData;
};
